import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.resourceAuthorization

export const getResourceAuthorization = createSelector(
  _getState,
  (state) => state.resourceAuthorization
)

export const getResourceAuthorizations = createSelector(
  _getState,
  (state) => state.resourceAuthorizations
)

export const getResourceAuthorizationIsLoading = createSelector(
  _getState,
  (state) => state.isLoading
)

export const getCurrentAgentNumber = createSelector(
  _getState,
  (state) => state.resourceAuthorization?.relationInfo?.agentNumber
)

export const selectCurrentRelationNumber = createSelector(
  _getState,
  (state) =>
    state.resourceAuthorization?.relationInfo?.relationNumber ?? undefined
)

export const selectServerTogglesForCurrent = createSelector(
  [(state) => state.resourceAuthorization.resourceAuthorization],
  (ra) => {
    const info = ra?.relationInfo

    if (!info) return undefined

    return {
      customerPanel: info.customerPanel ?? false,
      zestMagazine: info.zestMagazine ?? false,
      cooperationMembership: info.cooperationMembership ?? false
    }
  }
)

export const selectLocalOverridesForCurrent = createSelector(
  [
    (state) =>
      state.resourceAuthorization.localOverridesByRelation,
    selectCurrentRelationNumber
  ],
  (byRel, relationNumber) => {
    if (!relationNumber) return undefined
    const overrides = byRel[relationNumber]

    if (!overrides) return undefined
    if (overrides.expiresAt && overrides.expiresAt <= Date.now()) {
      return undefined
    }

    return overrides
  }
)

export const selectEffectiveTogglesForCurrent = createSelector(
  [selectServerTogglesForCurrent, selectLocalOverridesForCurrent],
  (server, local) => {
    if (!server) return undefined

    return {
      customerPanel: local?.customerPanel ?? server.customerPanel,
      zestMagazine: local?.zestMagazine ?? server.zestMagazine,
      cooperationMembership: local?.cooperationMembership ?? server.cooperationMembership
    }
  }
)
